import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";

import {
  type ErrorBoundryProps,
  GenericErrorBoundry,
} from "@av/components/templates/layouts/errors/error-boundry/GenericErrorBoundry";
import { jobsTheme } from "./config/antdJobsTheme";
import { JobsAppRoutes } from "./routes/JobsRoutes";

import type { LocaleProviderProps } from "antd/es/locale";

const queryClient = new QueryClient();

class JobsAppErrorBoundry extends GenericErrorBoundry {
  constructor(props: ErrorBoundryProps) {
    super(props);
    this.boundryName = "JobsAppErrorBoundry";
  }
}

/**
 * Standardized props interface for all Avanti sub-apps.
 *
 * This contract ensures consistent dependency injection from the root application
 * All sub-apps implement this interface to receive
 * shared dependencies while maintaining their own internal state and configuration.
 * This enables centralized management of cross-app concerns at the root level.
 */
type JobsAppProps = {
  currentAntdLocale: LocaleProviderProps["locale"];
};

// eslint-disable-next-line import/no-default-export
export default function JobsApp({ currentAntdLocale }: JobsAppProps) {
  return (
    <JobsAppErrorBoundry>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider theme={jobsTheme} locale={currentAntdLocale}>
          <JobsAppRoutes />
        </ConfigProvider>
      </QueryClientProvider>
    </JobsAppErrorBoundry>
  );
}
